export default __webpack_public_path__ + "static/media/uniswap.212597a4.png";